import {makeStyles} from '@material-ui/core/styles';

// const drawerWidth = 240;

export default makeStyles ((theme) => ({
    logoAppBar:{
        width: "120px",
    }
    ,barraDoodo:{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    }
}));